export const GET_TIME_ZONES = 'GET_TIME_ZONES';
export const GET_DISPLAY_TIMEZONE = 'GET_DISPLAY_TIMEZONE';
export const CLEAR_COUNTRIES_CACHE = 'CLEAR_COUNTRIES_CACHE';
export const GET_COUNTRIES_WITH_ADDRESS_CHECK = 'GET_COUNTRIES_WITH_ADDRESS_CHECK';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_CONVERSION_SETTINGS = 'GET_CONVERSION_SETTINGS';
export const GET_OFFER_SUPPORTED_LANGUAGES = 'GET_OFFER_SUPPORTED_LANGUAGES';
export const GET_OFFER_CATEGORIES = 'GET_OFFER_CATEGORIES';
export const GET_CREDIT_CARD_EXPIRATION_YEAR_LIST = 'GET_CREDIT_CARD_EXPIRATION_YEAR_LIST';
export const GET_STATES = 'GET_STATES';
export const GET_OFFER_VISIBILITY_VALUES = 'GET_OFFER_VISIBILITY_VALUES';

export const GET_TAGS = 'GET_TAGS';
export const GET_MACROS = 'GET_MACROS';